import { Injectable } from "@angular/core";
import { Actions, ofType, createEffect } from "@ngrx/effects";
import {
    ActionTypes,
    GetTransactionSiblingsDetailAction,
    GetTransactionSiblingsDetailFailAction,
    GetTransactionSiblingsDetailSucceedAction
} from "./transaction-siblings.actions";
import { switchMap, catchError, mergeMap } from "rxjs/operators";
import { of, Observable, forkJoin } from "rxjs";
import { PaymentsService } from "@admin_api/services/payments.service";
import { TransactionDetailDto } from "@admin_api/models/transaction-detail-dto";

@Injectable()
export class TransactionSiblingsEffects {

  constructor(
    private actions: Actions,
    private paymentsService: PaymentsService
  ) {}

  getTransactionSiblings = createEffect(() => this.actions.pipe(
        ofType<GetTransactionSiblingsDetailAction>(ActionTypes.GetTransactionSiblingsDetail),
        switchMap((action: GetTransactionSiblingsDetailAction) => {

            const transactionQueries: Observable<TransactionDetailDto>[] = [];
            action.tokens.forEach((transactionSibling) => {
                transactionQueries.push(this.paymentsService.transactionsGetTransaction({ token: transactionSibling }));
            });

            return forkJoin(transactionQueries).pipe(
                mergeMap(result => of(new GetTransactionSiblingsDetailSucceedAction(result))),
                catchError((error) => of(new GetTransactionSiblingsDetailFailAction(error)))
            );
        })
      ));

}
